/**
 * The platform's Automation addresses (Feature 74 D10): the page and the
 * linkage canvas. Every link to them is built here, so a move is one edit.
 */
export const AUTOMATION_PATH = '/automation';
export const NEW_LINKAGE_PATH = '/automation/linkages/new';

/** A linkage template's canvas. */
export function linkageCanvasPath(key: string): string {
  return `/automation/linkages/${encodeURIComponent(key)}`;
}
